import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { UnreachableCaseError } from "ts-essentials";

import { InvalidOperationException } from "../exceptions/exceptions";
import { ProductUrlPathSegment } from "../routes/shared/shared-route.constant";
import { Product } from "../store/shared/product";

@Injectable({ providedIn: "root" })
export class ProductService {
  private readonly _window: Window;

  constructor(@Inject(DOCUMENT) private _document: Document) {
    if (!this._document.defaultView) {
      throw new InvalidOperationException(
        "Was not able to find a global window object. This could be a side effect when changing to service side rendering (SSR)",
      );
    }

    this._window = this._document.defaultView;
  }

  getProduct() {
    const pathName = this._window.location.pathname;
    const matches = PRODUCT_REGEX.exec(pathName);

    if (!matches?.groups) {
      throw new InvalidOperationException(
        `Was not able to extract the product with a regular expressions from the path '${pathName}'`,
      );
    }

    const product = matches.groups["product"] as
      | ProductUrlPathSegment
      | undefined;

    if (!product) {
      throw new InvalidOperationException(
        `Could not find a named group in the regular expression with the name '${PRODUCT_REGEX_NAMED_GROUP}'`,
      );
    }

    switch (product) {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      case ProductUrlPathSegment.TERM_LIFE_INSURANCE:
        return Product.TERM_LIFE_INSURANCE_CONSTANT;
      case ProductUrlPathSegment.PILLAR_3A:
        return Product.PILLAR_3A_CONSTANT;
      default:
        throw new UnreachableCaseError(product);
    }
  }
}

// https://regex101.com/r/62bSmh/2
const PRODUCT_REGEX_NAMED_GROUP = "product";
const PRODUCT_REGEX = /^\/\w+\/(?<product>[\w-]+)\//;
